// lib
import React from "react";
import PropTypes from "prop-types";
import { IconButton, List, ListItem, ListItemIcon, ListItemText } from "@material-ui/core";
import { Add } from "@material-ui/icons";

const Groups = ({ createHandleSelect, items, selfTranslate }) => {
  if (!items) return null;
  return (
    <>
      <List dense>
        {items.map((i) => (
          <ListItem key={i.id}>
            <ListItemIcon onClick={createHandleSelect(i)}>
              <IconButton size="small" className="add">
                <Add />
              </IconButton>
            </ListItemIcon>
            <ListItemText primary={selfTranslate(i.display)} />
          </ListItem>
        ))}
      </List>
    </>
  );
};

Groups.propTypes = {
  // from parent
  createHandleSelect: PropTypes.func.isRequired,
  selfTranslate: PropTypes.func.isRequired,
  items: PropTypes.array,
};

Groups.defaultProps = {
  items: [],
};

export default Groups;
